import { ButtonProps } from "@toruslabs/vue-components/Button";

export const TOAST_TYPES = {
  SUCCESS: "success",
  ERROR: "danger",
  INFO: "info",
} as const;

export type ToastMessage = {
  type?: (typeof TOAST_TYPES)[keyof typeof TOAST_TYPES];
  message: string;
};

export type PaymentButtonType = {
  name: string;
  value: string;
  variant?: Extract<ButtonProps["variant"], "primary" | "secondary" | "tertiary">;
  icon?: string;
  class?: string;
};

export type NftType = {
  chain_id: string;
  chain_logo?: string;
  chain_name?: string;
  contract_address: string;
  contract_type: string;
  image_url: string;
  mint_limit: number;
  name: string;
  price: number;
  token_id?: null | number;
};

export type CheckoutResultType = "success" | "failed";
export type MintingStatusType = "success" | "failed";

export const MINT_ORDER_STATUS = {
  PROCESSING: "ready",
  TRANSACTION_SUBMITTED: "transaction_submitted",
  SUCCESSFUL: "successful",
  FAILED: "failed",
};

export type MintOrderStatusType = (typeof MINT_ORDER_STATUS)[keyof typeof MINT_ORDER_STATUS];

export type OrderMessageType = {
  status: MintOrderStatusType;
  mintedQuantity: number;
  mintedTokenIds: string;
  txnHash: string;
};

export type OrderType = {
  contract_type: string;
  token_id: number;
  status: string;
  quantity: number;
  minted_quantity: number;
  minted_ids: string;
  transaction_hash: string;
};
